module.exports = __webpack_public_path__ + "img/shape-6_gray-100.19c9bc9.png";